import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <div className="footer-logo">
              <i className="fas fa-calculator"></i>
              <span>Lakshaya Sivabalan</span>
            </div>
            <p>
              Providing expert financial guidance and accounting services to individuals and businesses 
              for over 15 years. Your trusted partner in financial success.
            </p>
          </div>
          <div className="footer-right">
            <div className="social-links">
              <a href="#" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="#" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" aria-label="Email">
                <i className="fas fa-envelope"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Lakshaya Sivabalan. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;